export const generateMathCaptcha = () => {
    const operations = ['+', '-', '*', '/'];

    const getRandomNumber = () => Math.floor(Math.random() * 90) + 10; // 10–99

    let num1 = getRandomNumber();
    let num2 = getRandomNumber();
    let op = operations[Math.floor(Math.random() * operations.length)];
    let expression = '';
    let answer = 0;

    if (op === '+') {
        expression = `${num1} + ${num2}`;
        answer = num1 + num2;
    } else if (op === '-') {
        if (num1 < num2) [num1, num2] = [num2, num1]; // Ensure positive result
        expression = `${num1} - ${num2}`;
        answer = num1 - num2;
    } else if (op === '*') {
        expression = `${num1} * ${num2}`;
        answer = num1 * num2;
    } else if (op === '/') {
        // Force clean division
        num2 = Math.floor(Math.random() * 9) + 1; // 1-9 divisor
        answer = Math.floor(Math.random() * 10 + 1); // small quotient
        num1 = num2 * answer;
        expression = `${num1} / ${num2}`;
    }

    return {
        expression,
        answer,
    };
};